export default {
  dateItem: {
    marginBottom: 8,
  },
};
